import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { StatsSection } from '../components/StatsSection';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { CredibilitySection } from '../components/CredibilitySection';
import { SystemSection } from '../components/SystemSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { ContactForm } from '../components/ContactForm';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-carbon text-white selection:bg-gold/30 selection:text-white font-sans" data-id="element-279">
      <Navbar data-id="element-280" />
      <main data-id="element-281">
        <HeroSection data-id="element-282" />
        <StatsSection data-id="element-283" />
        <DiagnosisSection data-id="element-284" />
        <CredibilitySection data-id="element-285" />
        <SystemSection data-id="element-286" />
        <TestimonialsSection data-id="element-287" />
        <FAQSection data-id="element-288" />
        <ContactForm data-id="element-289" />
        <FinalCTA data-id="element-290" />
      </main>
      <Footer data-id="element-291" />
    </div>;
}